import React from "react";
import Expandable from "../Expandable";
import { FaSchool } from "react-icons/fa";
import { FiBook, FiBookOpen } from "react-icons/fi";

const ExamMenu = (props) => {
  return (
    <Expandable
      {...props}
      icon={<FaSchool />}
      title="Exams"
      subArray={[
        {
          title: "Book exam",
          icon: <FiBook />,
          path: "/exams/new",
          accessLevel: 0,
          padLeft: "20px",
        },
        {
          title: "Manage exams",
          icon: <FiBookOpen />,
          path: "/exams/list",
          accessLevel: 0,
          padLeft: "20px",
        },
      ]}
    />
  );
};

export default ExamMenu;
